import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const DAYS_OF_WEEK = [1, 2, 3, 4, 5, 6, 7] as const;
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];

export const isDayOfWeek = (value: unknown): value is DayOfWeek =>
  typeof value === 'number' && DAYS_OF_WEEK.some(day => day === value);

export const MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const;

export const MONTH_TRANSLATED = defineMessages<(typeof MONTHS)[number]>({
  0: { id: 'app.months.january' },
  1: { id: 'app.months.february' },
  2: { id: 'app.months.march' },
  3: { id: 'app.months.april' },
  4: { id: 'app.months.may' },
  5: { id: 'app.months.june' },
  6: { id: 'app.months.july' },
  7: { id: 'app.months.august' },
  8: { id: 'app.months.september' },
  9: { id: 'app.months.october' },
  10: { id: 'app.months.november' },
  11: { id: 'app.months.december' },
});

export const DAY_OF_THE_WEEK_TRANSLATED = defineMessages<DayOfWeek>({
  1: { id: 'app.daysOfWeek.monday' },
  2: { id: 'app.daysOfWeek.tuesday' },
  3: { id: 'app.daysOfWeek.wednesday' },
  4: { id: 'app.daysOfWeek.thursday' },
  5: { id: 'app.daysOfWeek.friday' },
  6: { id: 'app.daysOfWeek.saturday' },
  7: { id: 'app.daysOfWeek.sunday' },
});

export const CRON_DAY_SHORT_TRANSLATED = defineMessages<DayOfWeek>({
  1: { id: 'app.components.ShortDayOfWeek.Monday' },
  2: { id: 'app.components.ShortDayOfWeek.Tuesday' },
  3: { id: 'app.components.ShortDayOfWeek.Wednesday' },
  4: { id: 'app.components.ShortDayOfWeek.Thursday' },
  5: { id: 'app.components.ShortDayOfWeek.Friday' },
  6: { id: 'app.components.ShortDayOfWeek.Saturday' },
  7: { id: 'app.components.ShortDayOfWeek.Sunday' },
});
